import { Separator } from "@/components/ui/separator"
import { MessageCircleQuestion } from "lucide-react"
import { Link } from "react-router-dom"


export const Footer = () => {
    return (
    <footer className="flex flex-col text-sm p-6 gap-4 bottom-0 border-t bg-slate-100 min-h-40">
        <div className="2xl:w-2/3 flex flex-row gap-4 items-center 2xl:mx-auto">
            <MessageCircleQuestion className="w-6 h-6"/>
            <a href="https://wa.me/56989326529" target="_blank" rel="noopener noreferrer" className="text-primary underline">
                <span className="text-sm">¿Tienes dudas?</span>
            </a>
        </div>
        <Separator orientation="horizontal" className="w-3/4 mx-auto"/>
        
        <div className="2xl:w-2/3 items-center 2xl:mx-auto" >
            <ul className="flex flex-row gap-4 w-full">
                <li><a href="https://carriapp.cl/service.terms.html">Términos del Servicio</a></li>
                <li><a href="https://carriapp.cl/privacy.policy.html">Politica de Privacidad</a></li>
            </ul>
        </div>
        <div className=" 2xl:w-2/3 items-center mx-auto my-2" >        
            <ul className="flex flex-row gap-8 w-full justify-center">
                <li>
                    <a href="https://www.linkedin.com/company/106798357" target="_blank" rel="noopener noreferrer">
                        <img className="w-10" src="https://storage.googleapis.com/carry_images/social/LI-In-Bug.png" alt="Linkedin"/>
                    </a>
                </li>
                <li>
                    <a href="https://www.instagram.com/carriapp_cl"  target="_blank" rel="noopener noreferrer">
                        <img className="w-9" src="https://storage.googleapis.com/carry_images/social/Instagram_Glyph_Gradient.png" alt="Instagram"/>
                    </a>
                </li>
                <li><img className="w-9" src="https://storage.googleapis.com/carry_images/social/Facebook_Logo_Primary.png" alt="Facebook"/></li>
                <li><img className="w-8" src="https://storage.googleapis.com/carry_images/social/logo-black.png" alt="X"/></li>
            </ul>
        </div>        
    </footer>)
}

